import {
  CalculatedValueDto,
  CalculatedValueResultDto,
  ValueSource
} from '@unistocks/proxy/axios-client';

/** Extra-property key carrying the asset id of an asset-sourced result (set by the API). */
export const assetIdExtraProperty = 'AssetId';

/**
 * Resolve the asset id of a value that represents a single asset, from either the input
 * DTO (settings) or the calculated result. Returns undefined for non-asset values so
 * callers can decide to make an entry navigable only when it points at an asset.
 */
export const getCalculatedValueAssetId = (
  value?: CalculatedValueDto | CalculatedValueResultDto
): string | undefined => {
  if (value?.valueSource !== ValueSource.Asset) return undefined;

  if ('params' in value) return value.params?.assets?.[0] ?? undefined;

  return value.extraProperties[assetIdExtraProperty] ?? undefined;
};
